import { lazy } from "react";
import Loadable from "components/Loadable";
import { FormatConstants, routeConstants } from "services/keyConstants";
import * as productListUrl from "pages/Product-Description/utils/urlHelperForProductList";
import { getStatusTypes } from "./service";
import { Eye } from "iconsax-react";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";

// Lazy-loaded components
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetailOld"))
);
const ProductHistoryRegister = Loadable(
  lazy(() => import("../ProductHistoryRegister"))
);

// Define route config to be consumed in MainRoutes
const finishedProductRegisterRoute = [
  {
    path: routeConstants.FINISHED_PRODUCT_REGISTER,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item) =>
                `/${routeConstants.FINISHED_PRODUCT_REGISTER}/${item?.productId}/${item?.variantId}`,
            }}
            customNavigateRoute={{
              url: (masterDocData, filterData, item, value) =>
                `/${routeConstants.FINISHED_PRODUCT_REGISTER}/detail/${item?.row?._id}/${value?.value?._id}`,
            }}
            otherDocData={{defaultName:FormatConstants.FINISHED_REGISTER_PRODUCT
                  .FINISHED_PRODUCT_REGISTER}}
            url={{ GET: productListUrl.GET_FILTERED_DOCS }}
            getStatusTypes={getStatusTypes}
            tableConfig={(item) => ({
              isHiddenActions: true,
              dynamicActions: {
                variants: {
                  isVisible: true,
                  type: "row",
                  actions: [
                    {
                      icon: <Eye />,
                      color: "success",
                      isActive: true,
                      isVisible: true,
                      handler: (data, value) =>
                        `/${routeConstants.FINISHED_PRODUCT_REGISTER}/detail/${data?.productId}/${data?.variantId}`,
                    },
                  ],
                },
              },
              dynamicViewMode: {
                variants: {
                  handler: (allData, data) => {
                    const { data: value } = data;

                    return (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {value?.map((val) => (
                            <Box
                              key={val?._id}
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                px: 1.5,
                                py: 0.5,
                                "&:hover": {
                                  backgroundColor: "#f5f5f5",
                                },
                                width: "fit-content",
                                maxWidth: "100%",
                              }}
                              component={Link}
                              to={`/${routeConstants.FINISHED_PRODUCT_REGISTER}/detail/${allData?.row?._id}/${val?._id}`}
                            >
                              <IconButton size="small" edge="start">
                                <Eye fontSize="small" />
                              </IconButton>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500, ml: 1 }}
                              >
                                {val?.variantName ?? "-"}{" "}
                                {val?.variantIdentificationCode ?? "-"}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      </>
                    );
                  },
                },
              },
            })}
          />
        ),
      },
      {
        path: "detail/:id/:childId",
        element: <ProductHistoryRegister />,
      },
    ],
  },
];

export default finishedProductRegisterRoute;
